// extracted by mini-css-extract-plugin
export default {"contents-container":"LewAOnvCX8UJMO0kNqq2","info-text-container":"_Ci7ZU1hWZX2QfIX6thb","table-container":"ylNc5sa3mk8wPlgkpxE2"};